<template lang="pug">
.message-confirm-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="submit")
    div(slot="modal-title")
      span.message-confirm-modal-title(v-if="validated == true") 以下の内容でメッセージを送信します。よろしいですか？
      span.message-confirm-modal-title(v-else) メッセージプレビュー

    .message-confirm-modal-body
      .header
        .address.d-flex.flex-row
          span(:class="_addressCssClass") 宛先： {{ _receivers }}
          .btn.address-toggle-btn
            .toggle-address.open(v-show="!isAddressOpen" @click="onAddressBadge()")
            .toggle-address.close(v-show="isAddressOpen" @click="onAddressBadge()")
      .body.d-flex.flex-column
        .message-text
          SendMessagePreview(v-model="functionContents" :replyLimit="getReplyLimit()")

    .message-confirm-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .d-flex.flex-column.flex-fill
        .d-flex.flex-fill.mb-2(v-if="showCheckbox == true && 0 < files.length")
          .d-flex.flex-column
            span.warning-message 家族全員へのメッセージで良いでしょうか？
            b-form-checkbox(v-model="checked") 確認しました
        .d-flex
          .file(v-if="0 < files.length")
            span.title 添付ファイル（{{ files.length }}）
            button.btn.preview-btn(@click="onPreview()") プレビュー
          .d-flex(v-if="showCheckbox == true && files.length <= 0")
            .d-flex.flex-column
              span.warning-message 家族全員へのメッセージで良いでしょうか？
              b-form-checkbox(v-model="checked") 確認しました
          .buttons
            button.btn.modal-ok-btn(v-if="validated == true" :class="{ 'disable': !checked }" :disabled="!checked"
              type="button" @click="ok()") OK
            button.btn.modal-cancel-btn(v-if="validated == true" type="button" @click="cancel()") キャンセル
            button.btn.modal-cancel-btn(v-else type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { LineReceiverDetail } from "@/commons/models/SendLineMessage";
import { SendMessageFunction } from "@/commons/models/Message";
import SendMessagePreview from "@/pc/basics/SendMessagePreview.vue";

/**
 * メッセージ送信確認モーダル
 */
@Component({
  components: {
    SendMessagePreview
  }
})
export default class SendMessageModal extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  files!: [];

  /** 表示対象のメッセージ */
  receivers: Array<LineReceiverDetail> = [];

  /** 表示対象のメッセージ */
  functionContents: any = {};

  /** 表示する情報がバリデーション済みか */
  validated: boolean = false;
  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスを表示するか否か */
  showCheckbox: boolean = false;
  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスのチェック */
  checked: boolean = false;

  /** 宛先CSSクラス */
  isAddressOpen: boolean = false;

  /**
   * ### モーダル表示
   */
  public show(receivers: Array<LineReceiverDetail>, functionContents: SendMessageFunction, validated: boolean, showCheckbox: boolean): void {
    this.receivers = receivers;
    this.functionContents = functionContents;
    this.validated = validated;
    this.showCheckbox = showCheckbox;
    this.checked = !showCheckbox;

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * ### メッセージ返信可能期限を返す
   */
  public getReplyLimit(): number {
    return userStore.facility.messageSettings.replyLimit;
  }

  get _receivers(): string {
    if (this.receivers == undefined) {
      return "";
    }

    let address: string = "";

    for (const receiver of this.receivers) {
      // 詳細タブの宛先は家族の場合は（部屋名・利用者名）をつけるように仕様変更になったのでここで判定する
      let receiverName: string = receiver.room != "" && receiver.residentName != "" ? `${receiver.name}（${receiver.room}・${receiver.residentName}）` : receiver.name;

      if (address == "") {
        address += receiverName;
      } else {
        address += "｜" + receiverName;
      }
    }

    return address;
  }

  get _addressCssClass(): string {
    if (this.isAddressOpen) {
      return "address-open";
    } else {
      return "address-close";
    }
  }

  /**
   * ### 宛先のオープン/クローズ切り替え
   */
  public onAddressBadge(): void {
    this.isAddressOpen = !this.isAddressOpen;

    return;
  }

  /**
   * ### プレビューボタン押下イベント
   */
  public onPreview(): void {
    this.$emit("preview");

    return;
  }

  /**
   * ### 送信するボタン押下イベント
   */
  public submit(): void {
    this.$emit("submit");

    return;
  }
}
</script>
